<template>
    <div class="rating-banner">
        <div class="rating-banner_prizes">
            <div class="rating-banner_prizes-wrapper">
                <img
                    alt="PS"
                    class="rating-banner_prizes-img"
                    src="@/assets/Competition/Raffle/macBook.png">
                <img
                    alt="macbook"
                    class="rating-banner_prizes-img"
                    src="@/assets/Competition/Raffle/iphone-orange.png">
                <img
                    alt="ipad"
                    class="rating-banner_prizes-img"
                    src="@/assets/Competition/Raffle/mac.png">
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "CompetitionRatingMiniBanner"
  };
</script>

<style lang="scss" scoped>
  @import "~@/scss/competition-banner";

  .rating-banner {
    $self: &;

    #{$self}_prizes-wrapper {
      width: 100%;
      height: 158px;


      #{$self}_prizes-img {
        content: "";
        position: absolute;
        object-fit: contain;

        &:nth-child(1) {
          bottom: -48px;
          left: -34px;
          z-index: 3;

          width: 264px;
          height: 194px;
        }

        &:nth-child(2) {
          bottom: -55px;
          left: 134px;
          z-index: 2;

          width: 300px;
          height: 230px;
        }

        &:nth-child(3) {
          bottom: -82px;
          left: 314px;
          z-index: 1;

          width: 300px;
          height: 262px;
        }
      }
    }
  }
</style>